"use strict";

var _taggedTemplateLiteral = require("/home/circleci/project/story/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledParagraph = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");

var _layout = require("@titelmedia/bricks-theme/lib/utilities/layout");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var StyledParagraph = _styledComponents.default.p(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  line-height: 1.4em;\n  ", "\n  ", "\n  ", "\n"])), (0, _typography.setFont)({
  bold: false
}), (0, _layout.setContainer)({
  size: 'sm'
}), (0, _typography.setFontSizes)({
  mobile: '16px',
  tablet_vertical: '20px'
}));

exports.StyledParagraph = StyledParagraph;